import React, { useCallback, useEffect, useRef } from "react";
import { AppRouter, AppProvider, CopyProvider } from "..";

import "./app.scss";

export const App: React.FC = () => {
  const playingRef = useRef(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const attemptToLoadAudio = useCallback(() => {
    if (audioRef.current !== null) {
      if (!playingRef.current) {
        audioRef.current.load();

        document.removeEventListener("click", attemptToLoadAudio);
      }
    }
  }, []);

  useEffect(() => {
    if (audioRef.current !== null) {
      ["click"].forEach(name => {
        document.addEventListener(name, attemptToLoadAudio);
      });

      audioRef.current.addEventListener("canplaythrough", () => {
        // @ts-ignore
        if (!playingRef.current) {
          playingRef.current = true;

          // @ts-ignore
          audioRef.current.volume = 0.2;
          // @ts-ignore
          audioRef.current.play();
        }
      });
    }
  }, [attemptToLoadAudio]);

  return (
    <AppProvider>
      <CopyProvider>
        <AppRouter />
      </CopyProvider>

      <audio
        ref={audioRef}
        src={process.env.PUBLIC_URL + "/kupi-full.mp3"}
        loop={true}
      />
    </AppProvider>
  );
};
